// TODO: update unit test
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import { compress, decompress } from './compression';

const Crypto = <T = any>(password: string) => {
  if (typeof password !== 'string')
    throw new Error('invalid password. it must be string');
  if (!password) throw new Error('Password is required');

  return {
    encrypt: (data: T): string => {
      const text: string = JSON.stringify(data);
      return AES.encrypt(text, password).toString();
    },
    decrypt: (cipherText: string | undefined): T | null => {
      if (!cipherText) {
        return null;
      }
      try {
        const text: string = AES.decrypt(cipherText, password).toString(Utf8);
        return JSON.parse(text) as T;
      } catch (e) {
        return null;
      }
    },
    compressAndEncrypt: (data: T): string => {
      const text: string = JSON.stringify(data);
      const compressedText = compress(text);
      return AES.encrypt(compressedText, password).toString();
    },
    decompressAndDecrypt: (cipherText: string | undefined): T | null => {
      try {
        if (!cipherText) {
          return null;
        }
        const text: string = AES.decrypt(cipherText, password).toString(Utf8);
        const decompressedText = decompress(text);
        return JSON.parse(decompressedText) as T;
      } catch (e) {
        return null;
      }
    },
  };
};
export default Crypto;
